/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  ApiKeyCreationResult,
  ApiKeyWithCompanyAndUsageSummaries,
} from "../models/index";
import {
  ApiKeyCreationResultFromJSON,
  ApiKeyCreationResultToJSON,
  ApiKeyWithCompanyAndUsageSummariesFromJSON,
  ApiKeyWithCompanyAndUsageSummariesToJSON,
} from "../models/index";

export interface CreateApiKeyRequest {
  name: string;
  description: string;
  companyId: string;
  daysUntilExpiration?: number | null;
  createdByUserId?: string | null;
  createdByEmail?: string | null;
}

export interface EditAPIKeyRequest {
  apiKeyId: string;
  name: string;
  description: string;
  isActive: boolean;
}

export interface GetApiKeyWithCompanyAndUsageDataRequest {
  apiKeyId: string;
}

export interface ListAllApiKeysRequest {
  textSearch?: string | null;
  isActive?: boolean | null;
  createdAt?: Array<string> | null;
  expiresAt?: Array<string> | null;
  lastUsed?: Array<string> | null;
  revokedAt?: Array<string> | null;
}

export interface RevokeApiKeyRequest {
  apiKeyId: string;
  reason: string;
}

/**
 *
 */
export class ApiKeysApi extends runtime.BaseAPI {
  /**
   */
  async createApiKeyRaw(
    requestParameters: CreateApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiKeyCreationResult>> {
    if (requestParameters["name"] == null) {
      throw new runtime.RequiredError(
        "name",
        'Required parameter "name" was null or undefined when calling createApiKey().',
      );
    }

    if (requestParameters["description"] == null) {
      throw new runtime.RequiredError(
        "description",
        'Required parameter "description" was null or undefined when calling createApiKey().',
      );
    }

    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling createApiKey().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["description"] != null) {
      queryParameters["description"] = requestParameters["description"];
    }

    if (requestParameters["daysUntilExpiration"] != null) {
      queryParameters["daysUntilExpiration"] =
        requestParameters["daysUntilExpiration"];
    }

    if (requestParameters["createdByUserId"] != null) {
      queryParameters["createdByUserId"] = requestParameters["createdByUserId"];
    }

    if (requestParameters["createdByEmail"] != null) {
      queryParameters["createdByEmail"] = requestParameters["createdByEmail"];
    }

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/api-keys/create-apollo-api-key`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiKeyCreationResultFromJSON(jsonValue),
    );
  }

  /**
   */
  async createApiKey(
    requestParameters: CreateApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiKeyCreationResult> {
    const response = await this.createApiKeyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async editAPIKeyRaw(
    requestParameters: EditAPIKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["apiKeyId"] == null) {
      throw new runtime.RequiredError(
        "apiKeyId",
        'Required parameter "apiKeyId" was null or undefined when calling editAPIKey().',
      );
    }

    if (requestParameters["name"] == null) {
      throw new runtime.RequiredError(
        "name",
        'Required parameter "name" was null or undefined when calling editAPIKey().',
      );
    }

    if (requestParameters["description"] == null) {
      throw new runtime.RequiredError(
        "description",
        'Required parameter "description" was null or undefined when calling editAPIKey().',
      );
    }

    if (requestParameters["isActive"] == null) {
      throw new runtime.RequiredError(
        "isActive",
        'Required parameter "isActive" was null or undefined when calling editAPIKey().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["apiKeyId"] != null) {
      queryParameters["apiKeyId"] = requestParameters["apiKeyId"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["description"] != null) {
      queryParameters["description"] = requestParameters["description"];
    }

    if (requestParameters["isActive"] != null) {
      queryParameters["isActive"] = requestParameters["isActive"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/api-keys/edit-apollo-api-key`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async editAPIKey(
    requestParameters: EditAPIKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.editAPIKeyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getApiKeyWithCompanyAndUsageDataRaw(
    requestParameters: GetApiKeyWithCompanyAndUsageDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiKeyWithCompanyAndUsageSummaries>>> {
    if (requestParameters["apiKeyId"] == null) {
      throw new runtime.RequiredError(
        "apiKeyId",
        'Required parameter "apiKeyId" was null or undefined when calling getApiKeyWithCompanyAndUsageData().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["apiKeyId"] != null) {
      queryParameters["apiKeyId"] = requestParameters["apiKeyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/api-keys/get-api-key-with-company-usage-data`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiKeyWithCompanyAndUsageSummariesFromJSON),
    );
  }

  /**
   */
  async getApiKeyWithCompanyAndUsageData(
    requestParameters: GetApiKeyWithCompanyAndUsageDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<ApiKeyWithCompanyAndUsageSummaries>> {
    const response = await this.getApiKeyWithCompanyAndUsageDataRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listAllApiKeysRaw(
    requestParameters: ListAllApiKeysRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiKeyWithCompanyAndUsageSummaries>>> {
    const queryParameters: any = {};

    if (requestParameters["textSearch"] != null) {
      queryParameters["textSearch"] = requestParameters["textSearch"];
    }

    if (requestParameters["isActive"] != null) {
      queryParameters["isActive"] = requestParameters["isActive"];
    }

    if (requestParameters["createdAt"] != null) {
      queryParameters["createdAt"] = requestParameters["createdAt"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    if (requestParameters["expiresAt"] != null) {
      queryParameters["expiresAt"] = requestParameters["expiresAt"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    if (requestParameters["lastUsed"] != null) {
      queryParameters["lastUsed"] = requestParameters["lastUsed"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    if (requestParameters["revokedAt"] != null) {
      queryParameters["revokedAt"] = requestParameters["revokedAt"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/api-keys/list-all-api-keys`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiKeyWithCompanyAndUsageSummariesFromJSON),
    );
  }

  /**
   */
  async listAllApiKeys(
    requestParameters: ListAllApiKeysRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<ApiKeyWithCompanyAndUsageSummaries>> {
    const response = await this.listAllApiKeysRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async revokeApiKeyRaw(
    requestParameters: RevokeApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["apiKeyId"] == null) {
      throw new runtime.RequiredError(
        "apiKeyId",
        'Required parameter "apiKeyId" was null or undefined when calling revokeApiKey().',
      );
    }

    if (requestParameters["reason"] == null) {
      throw new runtime.RequiredError(
        "reason",
        'Required parameter "reason" was null or undefined when calling revokeApiKey().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["apiKeyId"] != null) {
      queryParameters["apiKeyId"] = requestParameters["apiKeyId"];
    }

    if (requestParameters["reason"] != null) {
      queryParameters["reason"] = requestParameters["reason"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/api-keys/revoke-api-key`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async revokeApiKey(
    requestParameters: RevokeApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.revokeApiKeyRaw(requestParameters, initOverrides);
  }
}
